import React, { Component } from 'react'
import { Events, scrollSpy } from 'react-scroll'

import withWidth, { isWidthUp } from '@material-ui/core/withWidth'
import Divider from '@material-ui/core/Divider'
import Drawer from '@material-ui/core/Drawer'
import Grid from '@material-ui/core/Grid'
import Hidden from '@material-ui/core/Hidden'
import Toolbar from '@material-ui/core/Toolbar'

import MenuIcon from '@material-ui/icons/Menu'

import Navigation from '../../components/Navigation/Navigation'

import logoDark from '../../assets/images/logo-grey-30.png'
import logoWhite from '../../assets/images/logo-white-50.png'

import './Header.css'

const styles = {
  light: {
    background: 'rgba(255,255,255,.9)',
    fontSize: '1.5rem',
    boxShadow: '0 0 5px',
    transition: 'all .25s linear'
  },
  drawer: {
    width: '240px',
    padding: '1rem'
  },
  logoDrawer: {
    margin: '0 auto 1rem'
  }
}

class Header extends Component {
  state = {
    softNav: false,
    mini: false,
    sideNav: false
  }

  constructor (props) {
    super(props)

    this.closeSideNav = this.closeSideNav.bind(this)
    this.handleScroll = this.handleScroll.bind(this)
    this.openSideNav = this.openSideNav.bind(this)
  }

  componentDidMount() {
    this.setState({
      softNav: this.props.softNav,
      mini: !isWidthUp('md', this.props.width)
    })

    Events.scrollEvent.register('begin', this.handleScroll)
    Events.scrollEvent.register('end', this.handleScroll)
    scrollSpy.update()

    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    Events.scrollEvent.remove('scroll')

    window.removeEventListener('scroll', this.handleScroll)
  }

  getScroll() {
    if (window.pageYOffset !== undefined) {
      return window.pageYOffset
    } else {
      let sy
      let d = document
      let r = d.documentElement
      let b = d.body
      sy = r.scrollTop || b.scrollTop || 0
      return sy
    }
  }

  handleScroll(event) {
    let scrollTop = this.getScroll()
    this.setState({
      transform: scrollTop,
      mini: !isWidthUp('md', this.props.width) || scrollTop > 0
    })
  }

  openSideNav() {
    this.setState({
      sideNav: true
    })
  }

  closeSideNav() {
    this.setState({
      sideNav: false
    })
  }

  render() {
    return (
      <div>
        <Hidden mdUp={true}>
          <Drawer
            open={this.state.sideNav}
            onClose={this.closeSideNav}>
            <Grid container direction="column" style={styles.drawer}>
              <Grid item style={styles.logoDrawer}>
                <a href="/">
                  <img src={logoDark} className="logo" alt="logo" />
                </a>
              </Grid>
              <Divider />
              <Grid item>
                <Navigation
                  vertical={true}
                  soft={this.state.softNav}
                  onRef={this.closeSideNav}
                />
              </Grid>
            </Grid>
          </Drawer>
        </Hidden>
        <Toolbar style={this.state.mini ? styles.light : styles.dark}>
          <Grid container spacing={16} direction="row" alignItems="center">
            <Hidden mdUp={true}>
              <MenuIcon onClick={this.openSideNav} />
            </Hidden>
            <Grid item md={12}>
              <Grid container direction="row" justify="space-between" alignItems="center">
                <a href="/">
                  <img src={this.state.mini ? logoDark : logoWhite} className="logo" alt="logo" />
                </a>
                <Hidden smDown={true}>
                  <Navigation mini={this.state.mini} soft={this.state.softNav} />
                </Hidden>
              </Grid>
            </Grid>
          </Grid>
        </Toolbar>
      </div >
    )
  }
}

export default withWidth()(Header)


// WEBPACK FOOTER //
// ./src/components/Header/Header.js